import { useUser } from '~/api/user';
import { useTable } from '~/components';
import { ColumnIds } from '~/constants/table';

import { useDocumentsTableColumns } from './DocumentsTable.hooks';

export const DocumentsTable = () => {
  const { data: user } = useUser();

  const columns = useDocumentsTableColumns();
  const [table, Table] = useTable({
    data: user.documents,
    columns,
    initialState: {
      sorting: [
        {
          id: ColumnIds.documentsName,
          desc: false,
        },
      ],
    },
    enableSortingRemoval: false,
  });

  return (
    <Table.Root table={table}>
      <Table.Menu>
        <Table.Search />
      </Table.Menu>

      <Table.Grid>
        <Table.Header />
        <Table.Body>{(row) => <Table.Row row={row} />}</Table.Body>
      </Table.Grid>

      <Table.Pagination />
    </Table.Root>
  );
};
